const Default_Text_Color = 'rgb(0,0,0)'; // #000000 
const White_Text_Color = 'rgb(255,255,255)'; // #FFFFFF


export function colorContrastChecker(background_color, foreground_color=Default_Text_Color) {
  if (typeof(background_color) !== 'string') return;

  const background_color_arr = _getRGBArray(background_color);
  const back_luminance = _luminance(background_color_arr);

  const foreground_color_arr = _getRGBArray(foreground_color);
  const fore_luminance = _luminance(foreground_color_arr);

  const ratio = fore_luminance > back_luminance 
    ? ((back_luminance + 0.05) / (fore_luminance + 0.05))
    : ((fore_luminance + 0.05) / (back_luminance + 0.05));
  const  color_result = ratio < 1/4.5 ? foreground_color : White_Text_Color;

  return color_result;
}

function _getRGBArray(color_str) {
  let color_arr = [];
  if (color_str.startsWith('rgb')) {
    const c_str = color_str.substring(color_str.indexOf('(')+1, color_str.indexOf(')'));
    const c_str_arr = c_str.split(',', 3);
    color_arr = c_str_arr.map(c => { return Number(c) });
  }
  if (color_str.startsWith('hsl')) {
    const c_str = color_str.substring(color_str.indexOf('(')+1, color_str.indexOf(')'));
    const c_str_arr = c_str.split(',', 3);
    const color_arr_hsl =  c_str_arr.map(c => { return Number((c.split('%'))[0]) });
    color_arr = _hsvToRgb(color_arr_hsl);
  }
  return color_arr;
}
function _luminance(color_arr) {
  const a = color_arr.map((v) => {
    v /= 255;
    return v <= 0.03928
      ? v / 12.92
      : Math.pow( (v + 0.055) / 1.055, 2.4 );
  });
  const luminance = a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  
  return luminance;
}
function _hsvToRgb(hsl_arr) {
  /* from : https://blog.csdn.net/weixin_41424247/article/details/86520957 */
  let r = 0;
  let g = 0;
  let b = 0;

  const h = hsl_arr[0];
  const s = hsl_arr[1] / 100;
  const l = hsl_arr[2] / 100;

  const i = Number.parseInt( (h/60) % 6 );
  const f = h / 60 - i;
  const p = l * (1 - s);
  const q = l * (1 - (f * s));
  const t = l * (1 - (1 - f) * s);

  switch(i) {
  case 0:
    r = l;
    g = t;
    b = p;
    break;
    
  case 1:
    r = q;
    g = l;
    b = p;
    break;

  case 2:
    r = p;
    g = l;
    b = t;
    break;

  case 3:
    r = p;
    g = q;
    b = l;
    break;

  case 4:
    r = t;
    g = p;
    b = l;
    break;

  case 5:
    r = l;
    g = p;
    b = q;
    break;

  default: 
    break;
  }

  r = Number.parseInt(r * 255.0);
  g = Number.parseInt(g * 255.0);
  b = Number.parseInt(b * 255.0);

  return [r, g, b];
}